// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Search_Wrapper__cUpGS"};